<h5 mat-dialog-title mat-dialog-draggable-title>
  {{ "title.sign" | translate }}
  <button type="button" class="close" aria-label="Close" cdkFocusInitial (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</h5>
<mat-divider></mat-divider>
<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && saveSubmission()" appFocusFirstElement>
  <mat-dialog-content>
    <table mat-table [dataSource]="signers" class="mat-elevation-z8">
      <!-- fullName Column -->
      <ng-container matColumnDef="fullName">
        <th mat-header-cell *matHeaderCellDef>{{ 'form.full_name' | translate}}</th>
        <td mat-cell *matCellDef="let element" title="{{element.name}}"> {{element.name}} </td>
      </ng-container>
    
      <!-- userName Column -->
      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef>{{ 'form.username' | translate}}</th>
        <td mat-cell *matCellDef="let element" title="{{element.username}}"> {{element.username}} </td>
      </ng-container>
    
      <!-- enterprise Column -->
      <ng-container matColumnDef="enterprise">
        <th mat-header-cell *matHeaderCellDef>{{ 'form.enterprise' | translate}}</th>
        <td mat-cell *matCellDef="let element" title="{{element.enterprise}}"> {{element.enterprise}} </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': submission.idSigner == row.id}" (click)="highlight(row)"></tr>
    </table>
  </mat-dialog-content>
  <mat-dialog-actions align="center" class="pt-2 pb-3">
    <button mat-stroked-button color="primary" type="button" (click)="cancel()" class="mr-2">
      <mat-icon class="mr-0">cancel</mat-icon>{{ "button.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" type="submit" class="ml-2" [disabled]="submission.idSigner == ''">
      <mat-icon class="mr-0">save</mat-icon>{{ "button.save" | translate }}
    </button>
  </mat-dialog-actions>
</form>